// eslint-disable-next-line import/prefer-default-export
export const SnackbarTypeEnum = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
};
